"use client"
import { BASE_URL } from '@/utils/api';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useapi } from '@/helpers/apiContext';
import { MdWifiCalling3 } from "react-icons/md";

const Header = () => {
  const basic_detail = useapi()
  const { profile } = useapi()
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  // const [data, setdata] = useState()
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
      <header
        className={`${isSticky ? 'sticky top-0 bg-white  z-50 shadow-lg' : 'absolute top-0 bg-transparent'
          } left-0 right-0 `}
      >
        <div className='flex justify-between  transition-all duration-300 items-center p-4 text-black z-50 px-6 mx-auto w-full lg:w-[95%] 2xl:w-[77%] mt-2'>
          <div className="text-lg font-bold">
            <Link aria-label='Go to step home page' href="/" >
              {
                basic_detail.basic_detail
                  ?.logo_image ?
                  <Image src={basic_detail.basic_detail
                    ?.logo_image}
                    loading='eager'
                    priority
                    unoptimized
                    alt="logo"
                    width={230}
                    height={100} /> :
                  <Image src={'/images/logo1.svg'}
                    loading='eager'
                    priority
                    unoptimized
                    alt="logo"
                    width={230}
                    height={100} />
              }
            </Link>
          </div>
          <div className={`flex flex-col md:flex-row items-center md:space-x-8 transition-all duration-300 ${isOpen ? 'hidden' : 'hidden md:block'}`}>
            <div className="flex flex-col md:flex-row md:space-x-8 items-center">
              <span className="relative group cursor-pointer underlineHover font-medium text-lg text-black hover:text-orange">
                <Link href="/" aria-label='Go to  home page'>Home</Link>
              </span>
              {/* <Link href="/offline-courses" aria-label='Go to  courses page'>
                <span className="relative group cursor-pointer underlineHover font-medium text-lg text-black hover:text-orange">
                Offline Courses
                </span>
              </Link> */}
              <div className="relative group">
                <span className="relative  group cursor-pointer underlineHover font-medium text-lg text-black hover:text-orange !flex items-center">
                  Courses
                  <span
                    className="group-hover:roate-90"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 ml-1"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </span>
                <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                  <Link href="/courses" aria-label="Go to online courses page">
                    <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-orange">
                      Online Courses
                    </div>
                  </Link>
                  <Link href="/offline-courses" aria-label="Go to offline courses page">
                    <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-orange">
                      Offline Courses
                    </div>
                  </Link>
                </div>
              </div>
              <span className="cursor-pointer underlineHover font-medium text-lg text-black hover:text-orange">
                <Link href={'/contact'} aria-label='Go to  home page'>
                  Contact Us
                </Link>
              </span>

              <button className="mr-5 hidden sm:flex bg-orange items-center justify-center px-2 w-[40px] h-[40px] py-[8px] 2xl:py-3 text-white bg-pink hover:bg-pinkdarker rounded-full transition duration-300">
                <span
                  className="font-semibold text-[24px]"
                  style={{
                    animation: "shake 0.5s ease-in-out infinite",
                    display: "inline-block",
                  }}
                >
                  <Link
                    href={`tel:+91-9887555600`}
                    aria-label="Talk To our Team"
                    title="Talk To our Team"
                  >
                    <MdWifiCalling3 />
                  </Link>

                </span>
              </button>
              {
                !Cookies.get('login_access_token') &&
                <span className="cursor-pointer underlineHover font-medium text-lg text-orange">
                  <Link href="/signup" aria-label='Go to signup page'>
                    Sign Up
                  </Link>
                </span>
              }
              {
                !Cookies.get('login_access_token') &&
                <p className="cursor-pointer smooth1 hover:text-white font-medium text-lg border
              border-orange px-4 py-2 rounded-lg text-orange hover:bg-orange">
                  <Link href="/login" aria-label='Go to Login page'>Log In</Link>
                </p>
              }
              {
                Cookies.get('login_access_token') &&
                <div className="cursor-pointer  font-medium text-lg text-orange">
                  {/* <Link href="/dashboard"> */}
                  <div className='flex gap-2 items-center' onClick={() => {
                    router.push('/dashboard');
                  }}>
                    {/* <div className='size-[35px] md:size-[50px] rounded-full bg-orange border-4 border-red-200 text-[20px] md:text-[27px] center text-white capitalize'>
                      {profile?.username[0]}
                    </div>
                    <div className='cursor-pointer'>
                      <p className='text-[16px] font-semibold'>{profile?.username}</p>
                      <p className='text-[14px] hidden md:block -mt-2 font-medium text-[#616161]'>{profile?.email}</p>
                    </div> */}
                    <div className="rounded-md ">
                      <button className="px-3 py-[5px] rounded-md bg-orange  text-white  hover:bg-orange/30 hover:text-orange transition duration-200">
                        Dashboard
                      </button>
                      {/* <a href="#" className="px-4 py-2 bg-orange-600  rounded-lg hover:bg-orange-500 transition duration-200">Download PDF-2</a> */}
                    </div>
                  </div>
                  {/* </Link> */}
                </div>
              }
            </div>

          </div>
          <button className="md:hidden p-2 text-2xl text-orange" onClick={toggleSidebar}>
            ☰
          </button>
        </div>
      </header>
      {isOpen && (
        <div className="sticky top-20 z-40 left-0 right-0 bg-white shadow-lg p-4 md:hidden">
          <div className="flex flex-col space-y-4">
            <Link href={'/'} aria-label='Go to  home page'>
              <li className="cursor-pointer text-lg text-black hover:text-orange">Home</li>
            </Link>
            <Link href={'/courses'} aria-label='Go to  courses page'>
              <li className="cursor-pointer text-lg text-black hover:text-orange">
                Online Courses
                {/* <ul className="flex flex-col space-y-2 mt-2">
                <li className="px-4 py-2 hover:bg-gray-200">Web Development</li>
                <li className="px-4 py-2 hover:bg-gray-200">App Development</li>
                <li className="px-4 py-2 hover:bg-gray-200">SEO Services</li>
              </ul> */}
              </li>
            </Link>
            <Link href={'/offline-courses'} aria-label='Go to  contact page'>
              <li className={`cursor-pointer text-lg text-black hover:text-orange`}> Offline Courses</li>
            </Link>
            <Link href={'/contact'} aria-label='Go to  contact page'>
              <li className={`cursor-pointer text-lg text-black hover:text-orange`}>Contact Us</li>
            </Link>
            {
              !Cookies.get('login_access_token') &&
              <Link href={'/signup'} aria-label='Go to  Signup page' >
                <li className="cursor-pointer text-lg text-orange">Sign Up</li>
              </Link>
            }
            {
              !Cookies.get('login_access_token') &&
              <Link href={'/login'} aria-label='Go to  login page'>
                <p className="cursor-pointer smooth1 hover:text-white border border-orange px-4 py-2 rounded-lg text-orange hover:bg-orange">Log In</p>
              </Link>
            }
            {
              Cookies.get('login_access_token') &&
              <div className="cursor-pointer  font-medium text-lg text-orange">
                {/* <Link href="/dashboard"> */}
                <div className='flex gap-2 items-center' onClick={() => {
                  router.push('/dashboard');
                }}>
                  {/* <div className='size-[35px] md:size-[50px] rounded-full bg-orange border-4 border-red-200 text-[20px] md:text-[27px] center text-white capitalize'>
                    {profile?.username[0]}
                  </div>
                  <div className='cursor-pointer'>
                    <p className='text-[16px] font-semibold'>{profile?.username}</p>
                    <p className='text-[14px] hidden md:block -mt-2 font-medium text-[#616161]'>{profile?.email}</p>
                  </div> */}
                  <div className="rounded-md ">
                    <button className="px-3 py-[5px] rounded-md bg-orange  text-white  hover:bg-orange/30 hover:text-orange transition duration-200">
                      Dashboard
                    </button>
                  </div>
                </div>
                {/* </Link> */}
              </div>
            }
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
